import { NgModule } from '@angular/core';

import { LcsOptionComponent } from './option/option.component';

@NgModule({
   declarations: [LcsOptionComponent],
   exports: [LcsOptionComponent],
})
export class SelectModule {}
